
import Header from "../admin/components/Header";
import Footer from "../admin/components/Footer";

const AdminLayout = ({ children }) => {
  return (<>
    <div className="DashboardMainBody">
      <Header />
      {children}
    </div>
    <Footer menuName={children?.props?.menuName} />
  </>);
};

export default AdminLayout;